import AbsComponent from "../AbsComponent";

class SelectBox extends AbsComponent {
    constructor(_store={}, _router={}, _el=' .gd-filter-condition-typesoper .gd-select', _datastr='typesOper', _selstr='selTypesOper', _paramStr='typesoper'){
        super('class SelectBox', _store, _router, _el);

        this.selstr = _selstr;
        this.paramStr = _paramStr;

        let watchData = this.watch(this.store.getState, _datastr, this.isEqual);
        this.store.subscribe( watchData( (newVal, oldVal, path) => this.render(newVal, oldVal, path) ) );

        let watchSel = this.watch(this.store.getState, this.selstr, this.isEqual);
        this.store.subscribe( watchSel( (_newVal, _oldVal, _path) => this.select(_newVal) ) );

        this.addEvents();
    }

    addEvents(){
        $( this.el ).on('change', (e)=>{
            let obj = {};
                obj[this.paramStr] = $( this.el + ` option:selected`).val();
                
            // this.store.dispatch( this.actions.setStopListLoad(true) );
            // this.store.dispatch( this.actions.setListpage( 1 ) );
            this.router.goMultiParamSetListPage( obj );
            // this.store.dispatch( this.actions.setStopListLoad(false) );
            // this.store.dispatch( this.actions.loadItemList(1) );
        });
    }

    render(_newVal, _oldVal, _path){
        let list = _newVal.map( it => `<option value="${it.id}">${it.name}</option>` );
        $( this.el ).html(list);
        this.select(this.store.getState()[this.selstr])
    }

    select(_newVal){
        if (_newVal==='' || _newVal===null) {
            $( this.el + ` option` ).first().prop("selected", true);
        }else{
            $( this.el + ` option[value="${_newVal}"]` ).prop("selected", true);
        }
    }

} // end of class
export default SelectBox;